<template>
    <div class="mt-3 pr-3" :style="reviews.length > 0 ? 'height: 30rem; overflow-y: scroll;' : ''">
        <template v-if="user">
            <template v-if="!userHasReview">
                <button v-if="user.isVerified" type="button" class="btn btn-outline-primary mr-1"
                        style=" margin-left: 10px; margin-right: 10px; line-height: 15px; border-radius: 40px;"
                        data-toggle="modal" data-target="#myModal">
                    Leave a review
                </button>
                <div v-else>
                    <p class="text-danger mb-3 mt-3 ml-2">Reviews can only be posted by accounts that have been verified. Click the button below to send a verification email to your account”.</p>
                   <a  :href="'/email/verify/' + user.userID" class="btn btn-outline-primary mr-1"
                       style="margin-left: 10px; margin-right: 10px; line-height: 15px; border-radius: 40px;">
                        Verify to leave a review
                    </a>
                </div>
            </template>
        </template>
        <a v-else href="/login" class="btn btn-outline-primary mr-1"
           style="margin-left: 10px; margin-right: 10px; line-height: 15px; border-radius: 40px;">
            Sign in to leave a review
        </a>

        <div v-if="reviews.length > 0" class="mt-2">
            <div v-for="review in reviews" class="py-1 w-100">
                <div class="rounded p-3" style="background-color: #f2f2f2">
                    <div class="row">
                        <div class="col-12 col-sm-6 font-weight-bold">{{ review.user.username }}</div>
                        <button v-if="user && user.userID === review.user.userID"
                                class="col-12 col-sm-6 text-left text-sm-right delete-review" type="button"
                                data-toggle="modal" data-target="#deleteReview">
                            Delete Review
                        </button>
                    </div>

                    <display-review :score="review.score"
                                    :display-card="true">
                    </display-review>
                    <div class="small">{{ review.timestamp }}</div>
                    <div>{{ review.comment }}</div>

                    <div v-if="review.reply" class="mt-3 border p-2">
                        <div class="font-weight-bold">{{ businessName }}</div>
                        <div class="small">{{ review.replyTimestamp }}</div>
                        <div>{{ review.reply }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="card w-100 mt-3 pt-3">
            <img class="mx-auto" width="70" height="70" src="/images/svg/heart-broken.svg" alt="heart-broken">
            <div class="card-body">
                <div class="row pl-3">
                    <h6 class="mx-auto">
                        <span>We currently have no reviews. Be the first to leave one!</span>
                    </h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReviewTab",
    props: {
        user: Object,
        reviews: Array,
        businessName: String,
    },
    data() {
        return {}
    },
    computed: {
        userHasReview: function () {
            //user must be logged in
            if (this.user) {
                //loop through business reviews
                if(this.$attrs['hasReview'])
                    return true;

                for (let i = 0; i < this.reviews.length; i++) {
                    //if the signed in user has left a review then return true
                    if (this.reviews[i].user.userID === this.user.userID)
                        return true;


                }
            }
            return false;
        }
    }
}
</script>

<style scoped>
/*Review delete button*/
.delete-review {
    color: #00937F;
    background-color: transparent;
    border: none;
    outline: none;
}

.delete-review:hover {
    color: #FF7546;
    outline: none;
}
</style>
